import api from './api';
import type { OwnershipAccount, OwnershipAccountType, PaginatedResponse } from '../types/venue';

const base = (venueId: string) => `/admin/venue/${venueId}/ownership-accounts`;

export interface OwnershipAccountPayload {
  name: string;
  type: OwnershipAccountType;
  supplierId?: string | null;
  isVenueDefault?: boolean;
  active?: boolean;
  notes?: string;
}

const ownershipAccountService = {
  listAccounts: async (
    venueId: string,
    params?: { type?: OwnershipAccountType; active?: boolean },
  ): Promise<PaginatedResponse<OwnershipAccount>> => {
    const response = await api.get(base(venueId), { params: { pageSize: 200, ...params } });
    return response.data;
  },

  getAccount: async (venueId: string, accountId: string): Promise<OwnershipAccount> => {
    const response = await api.get(`${base(venueId)}/${accountId}`);
    return response.data;
  },

  createAccount: async (
    venueId: string,
    payload: OwnershipAccountPayload,
  ): Promise<OwnershipAccount> => {
    const response = await api.post(base(venueId), payload);
    return response.data;
  },

  updateAccount: async (
    venueId: string,
    accountId: string,
    payload: Partial<OwnershipAccountPayload>,
  ): Promise<OwnershipAccount> => {
    const response = await api.patch(`${base(venueId)}/${accountId}`, payload);
    return response.data;
  },
};

export default ownershipAccountService;
